import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { OFFLINE_CAPABILITY_MESSAGE } from '@/lib/offlineCapability';

export function OfflineBanner() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="sticky top-0 z-[70] border-b border-amber-400/30 bg-amber-500/15 px-4 py-3 text-sm font-semibold text-amber-100">
      {OFFLINE_CAPABILITY_MESSAGE}
    </div>
  );
}
